import { z } from "zod";

import { PluginCurrencySchema } from "../config";
import { PluginTrafficConfigSchema_2023_08_20 } from "../config/experiments";
import { PluginRedirectSchema_2023_08_20 } from "../config/redirects/2023-08-20";
import { PluginConfigVersionList } from "../versions";

const PluginInitTestGroupSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  percentage: z.number(),
  isControl: z.boolean().default(false),
  customCss: z.string().nullish(),
  customJs: z.string().nullish(),
});

const PluginInitExperimentSchema_2023_08_20 = z.object({
  id: z.string().uuid(),
  isPreview: z.boolean().optional().default(true),
  hasTestPricing: z.boolean().default(true),
  hasTestCampaign: z.boolean().default(false),
  measurementId: z.string().optional(),
  testGroups: PluginInitTestGroupSchema.array(),
  trafficConfig: PluginTrafficConfigSchema_2023_08_20.nullish(),
  findReplaceSelectors: z.string().array().nullish(),
});
export type PluginInitExperimentType_2023_08_20 = z.infer<
  typeof PluginInitExperimentSchema_2023_08_20
>;

const PluginInitRedirectSchema_2023_08_20 = PluginRedirectSchema_2023_08_20;

const PluginInitOptionsSchema = z.object({
  domain: z.string().nullish(),
  isHeadlessStorefront: z.boolean().nullish(),
  shouldRedirect: z.boolean().nullish(),
  locale: z.string().nullish(),
  metricsSampleRate: z.number().nullish(),
  useBrowserLocale: z.boolean().nullish(),
  currencyFnString: z.string().nullish(),
  priceSlittingEnabled: z.boolean().nullish(),
  currencyFormat: PluginCurrencySchema.nullish(),
  eagerUpdateDom: z.boolean().nullish(),
  shopifyFunctionsEnabled: z.boolean().nullish(),
  shopifyFunctionsForPricingEnabled: z.boolean().nullish(),
  lazyCartUpdate: z.boolean().nullish(),
  useBeacon: z.boolean().nullish(),
});

const PluginInitCampaignSchema = z.object({
  id: z.string().uuid().optional(),
  name: z.string(),
  isPreview: z.boolean(),
  requiresLink: z.boolean(),
  findReplaceSelectors: z.string().array().nullish(),
});

const PluginInitExclusionGroupEntitySchema = z.object({
  id: z.string().uuid(),
  entityId: z.string().uuid(),
  order: z.number(),
  hasPriorityOrder: z.boolean(),
  percentage: z.number(),
});

const PluginInitExclusionGroupSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  reassignOnEnd: z.boolean(),
  hasWeightedValues: z.boolean(),
  exclusionGroupEntities: PluginInitExclusionGroupEntitySchema.array().default(
    []
  ),
});

export const PluginInitConfigSchema_2023_08_20 = z.object({
  storeName: z.string(),
  orgId: z.string().uuid(),
  buildId: z.number(),
  version: z.enum(PluginConfigVersionList),
  priceSelectors: z.string().array().nullish(),
  stayAiSelectors: z.string().array().nullish(),
  experiments: PluginInitExperimentSchema_2023_08_20.array().default([]),
  campaigns: PluginInitCampaignSchema.array().default([]),
  redirects: PluginInitRedirectSchema_2023_08_20.array().default([]),
  options: PluginInitOptionsSchema,
  exclusionGroups: PluginInitExclusionGroupSchema.array().default([]),
});

export type PluginInitConfigType_2023_08_20 = z.infer<
  typeof PluginInitConfigSchema_2023_08_20
>;
